// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as ReservaConfirmadaRouteImport } from './routes/reserva-confirmada'
import { Route as PrivacidadRouteImport } from './routes/privacidad'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as AvisoLegalRouteImport } from './routes/aviso-legal'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProductsAgenteRouteImport } from './routes/products.agente'
import { Route as ServicesIndexRouteImport } from './routes/services.index'
import { Route as ServicesPaquetesRouteImport } from './routes/services.paquetes'
import { Route as ServicesCasosRouteImport } from './routes/services.casos'
import { Route as ServicesAreasRouteImport } from './routes/services.areas'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as AboutIndexRouteImport } from './routes/about.index'
import { Route as AboutOficinasRouteImport } from './routes/about.oficinas'
import { Route as AboutMisionRouteImport } from './routes/about.mision'
import { Route as AboutEquipoRouteImport } from './routes/about.equipo'
import { Route as ClientsClientProjectsIndexRouteImport } from './routes/clients.$client.projects.index'
import { Route as ProposalsLegalAgente2026RouteImport } from './routes/proposals.legal.agente.2026'
import { Route as ProposalsFunAgente2026RouteImport } from './routes/proposals.fun.agente.2026'
import { Route as ClientsClientProjectsProjectIndexRouteImport } from './routes/clients.$client.projects.$project.index'

const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const ReservaConfirmadaRoute = ReservaConfirmadaRouteImport.update({
            id: '/reserva-confirmada',path: '/reserva-confirmada',getParentRoute: () => rootRouteImport
          })
const PrivacidadRoute = PrivacidadRouteImport.update({
            id: '/privacidad',path: '/privacidad',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const AvisoLegalRoute = AvisoLegalRouteImport.update({
            id: '/aviso-legal',path: '/aviso-legal',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ProductsAgenteRoute = ProductsAgenteRouteImport.update({
            id: '/products/agente',path: '/products/agente',getParentRoute: () => rootRouteImport
          })
const ServicesIndexRoute = ServicesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ServicesRoute
          })
const ServicesPaquetesRoute = ServicesPaquetesRouteImport.update({
            id: '/paquetes',path: '/paquetes',getParentRoute: () => ServicesRoute
          })
const ServicesCasosRoute = ServicesCasosRouteImport.update({
            id: '/casos',path: '/casos',getParentRoute: () => ServicesRoute
          })
const ServicesAreasRoute = ServicesAreasRouteImport.update({
            id: '/areas',path: '/areas',getParentRoute: () => ServicesRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })
const AboutIndexRoute = AboutIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AboutRoute
          })
const AboutOficinasRoute = AboutOficinasRouteImport.update({
            id: '/oficinas',path: '/oficinas',getParentRoute: () => AboutRoute
          })
const AboutMisionRoute = AboutMisionRouteImport.update({
            id: '/mision',path: '/mision',getParentRoute: () => AboutRoute
          })
const AboutEquipoRoute = AboutEquipoRouteImport.update({
            id: '/equipo',path: '/equipo',getParentRoute: () => AboutRoute
          })
const ClientsClientProjectsIndexRoute = ClientsClientProjectsIndexRouteImport.update({
            id: '/clients/$client/projects/',path: '/clients/$client/projects/',getParentRoute: () => rootRouteImport
          })
const ProposalsLegalAgente2026Route = ProposalsLegalAgente2026RouteImport.update({
            id: '/proposals/legal/agente/2026',path: '/proposals/legal/agente/2026',getParentRoute: () => rootRouteImport
          })
const ProposalsFunAgente2026Route = ProposalsFunAgente2026RouteImport.update({
            id: '/proposals/fun/agente/2026',path: '/proposals/fun/agente/2026',getParentRoute: () => rootRouteImport
          })
const ClientsClientProjectsProjectIndexRoute = ClientsClientProjectsProjectIndexRouteImport.update({
            id: '/clients/$client/projects/$project/',path: '/clients/$client/projects/$project/',getParentRoute: () => rootRouteImport
          })





const AboutRouteChildren = {
  AboutEquipoRoute: AboutEquipoRoute,AboutMisionRoute: AboutMisionRoute,AboutOficinasRoute: AboutOficinasRoute,AboutIndexRoute: AboutIndexRoute
}

const AboutRouteWithChildren = AboutRoute._addFileChildren(AboutRouteChildren)




const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)




const ServicesRouteChildren = {
  ServicesAreasRoute: ServicesAreasRoute,ServicesCasosRoute: ServicesCasosRoute,ServicesPaquetesRoute: ServicesPaquetesRoute,ServicesIndexRoute: ServicesIndexRoute
}

const ServicesRouteWithChildren = ServicesRoute._addFileChildren(ServicesRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRouteWithChildren,AdminRoute: AdminRoute,AvisoLegalRoute: AvisoLegalRoute,BlogRoute: BlogRouteWithChildren,ContactRoute: ContactRoute,CookiesRoute: CookiesRoute,PrivacidadRoute: PrivacidadRoute,ReservaConfirmadaRoute: ReservaConfirmadaRoute,ServicesRoute: ServicesRouteWithChildren,ProductsAgenteRoute: ProductsAgenteRoute,ProposalsFunAgente2026Route: ProposalsFunAgente2026Route,ProposalsLegalAgente2026Route: ProposalsLegalAgente2026Route,ClientsClientProjectsIndexRoute: ClientsClientProjectsIndexRoute,ClientsClientProjectsProjectIndexRoute: ClientsClientProjectsProjectIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)